module.exports = __webpack_public_path__ + "static/logo.c55228d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/parts/home/Projects/projects/eddywolff/logo.png
// module id = 504
// module chunks = 35783957827783